import { calculateBaziChart } from "@openfate/bazi-engine";

export const DEFAULT_BIRTH_HOUR = 12;

const HOUR_PERIODS = [
  "23:00-01:00", "01:00-03:00", "03:00-05:00", "05:00-07:00",
  "07:00-09:00", "09:00-11:00", "11:00-13:00", "13:00-15:00",
  "15:00-17:00", "17:00-19:00", "19:00-21:00", "21:00-23:00",
];

const PERIOD_REPRESENTATIVE_HOURS = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
const DEFAULT_PERIOD_INDEX = 6;

export const BIRTH_HOUR_PERIOD_OPTIONS = HOUR_PERIODS.map((period, index) => ({
  value: PERIOD_REPRESENTATIVE_HOURS[index],
  period,
  isDefault: index === DEFAULT_PERIOD_INDEX,
}));

export function birthHourToSelectValue(raw) {
  if (raw === "" || raw == null) return "";
  const hour = Number(raw);
  if (!Number.isFinite(hour)) return "";
  const index = Math.floor((hour + 1) / 2) % 12;
  const option = BIRTH_HOUR_PERIOD_OPTIONS[index];
  return option.isDefault ? "" : String(option.value);
}

const BRANCH_CHAR_TO_ANIMAL = {
  子: "Rat",
  丑: "Ox",
  寅: "Tiger",
  卯: "Rabbit",
  辰: "Dragon",
  巳: "Snake",
  午: "Horse",
  未: "Goat",
  申: "Monkey",
  酉: "Rooster",
  戌: "Dog",
  亥: "Pig",
};

const ELEMENT_TO_ENGLISH = {
  wood: "Wood",
  fire: "Fire",
  earth: "Earth",
  metal: "Metal",
  water: "Water",
};

const PILLAR_KEYS = ["year", "month", "day", "hour"];

export function parsePartnerBirthDate(isoDate) {
  if (!isoDate || typeof isoDate !== "string") return null;
  const match = isoDate.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) return null;
  return { year, month, day };
}

export function normalizeBirthHour(raw) {
  if (raw === "" || raw == null) return DEFAULT_BIRTH_HOUR;
  const hour = Number(raw);
  if (!Number.isFinite(hour)) return DEFAULT_BIRTH_HOUR;
  return Math.min(23, Math.max(0, Math.floor(hour)));
}

export function buildBaziChart({ year, month, day, hour, gender = "male" }) {
  return calculateBaziChart({
    year,
    month,
    day,
    hour: normalizeBirthHour(hour),
    minute: 0,
    gender,
    enableTrueSolarTime: false,
    calendarType: "solar",
  });
}

export function pillarAnimal(branchChar) {
  return BRANCH_CHAR_TO_ANIMAL[branchChar] || "Rat";
}

export function pillarElementEnglish(elementKey) {
  return ELEMENT_TO_ENGLISH[elementKey] || "Earth";
}

export function serializePillars(chart) {
  return PILLAR_KEYS.map((key) => {
    const pillar = chart.pillars[key];
    if (!pillar) return null;
    return {
      key,
      ganZhi: pillar.ganZhi,
      stem: pillar.stem,
      branch: pillar.branch,
      animal: pillarAnimal(pillar.branch),
      element: pillarElementEnglish(pillar.element),
      branchElement: pillarElementEnglish(pillar.branchElement),
    };
  }).filter(Boolean);
}

export function elementCountsFromPillars(pillars) {
  const counts = { Wood: 0, Fire: 0, Earth: 0, Metal: 0, Water: 0 };
  pillars.forEach((pillar) => {
    if (counts[pillar.element] != null) counts[pillar.element] += 1;
    if (counts[pillar.branchElement] != null) counts[pillar.branchElement] += 0.5;
  });
  return counts;
}

export function serializeDaYun(chart) {
  return (chart.daYun?.cycles || []).slice(0, 9).map((cycle) => ({
    index: cycle.index,
    ganZhi: cycle.ganZhi,
    stem: cycle.stem,
    branch: cycle.branch,
    startYear: cycle.startYear,
    endYear: cycle.endYear,
    startAge: cycle.startAge,
    endAge: cycle.endAge,
    animal: pillarAnimal(cycle.branch),
  }));
}
